import React from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaRegEnvelope, FaTrashAlt } from "react-icons/fa";

import SectionCard from "./SectionCard";

import {
  formatDateTime,
  getMessageDate,
  getReadButtonLabel,
} from "../utils/dashboardUtils";

export default function MessagesPreviewCard({
  loading,
  messages = [],
  unreadCount = 0,
  onToggleRead,
  onDelete,
}) {
  const displayedMessages = messages.slice(0, 5);

  return (
    <SectionCard
      icon={FaEnvelope}
      title="Messages reçus"
      subtitle="Derniers messages envoyés depuis le formulaire de contact."
      action={
        <Link
          to="/appli/messages-contact"
          className="rounded-2xl border border-slate-200 px-3 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800"
        >
          Voir tout
        </Link>
      }
    >
      <div className="mb-4 flex items-center justify-between rounded-2xl bg-slate-50 px-4 py-3 dark:bg-slate-950">
        <span className="text-sm text-slate-500 dark:text-slate-400">
          Messages non lus
        </span>
        <span className="rounded-full bg-rose-500 px-3 py-1 text-sm font-bold text-white">
          {unreadCount}
        </span>
      </div>

      {loading ? (
        <div className="space-y-3">
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className="h-24 animate-pulse rounded-3xl bg-slate-100 dark:bg-slate-800"
            />
          ))}
        </div>
      ) : displayedMessages.length > 0 ? (
        <div className="space-y-3">
          {displayedMessages.map((message) => {
            const isRead = Boolean(message.read_message);

            return (
              <article
                key={message.id}
                className={`rounded-3xl border p-4 transition ${
                  isRead
                    ? "border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900"
                    : "border-orange-200 bg-orange-50/70 dark:border-orange-500/30 dark:bg-orange-500/10"
                }`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-2">
                      <p className="truncate text-sm font-bold text-slate-950 dark:text-white">
                        {message.name || "Contact"}
                      </p>

                      {!isRead && (
                        <span className="rounded-full bg-rose-500 px-2 py-0.5 text-[11px] font-bold text-white">
                          Nouveau
                        </span>
                      )}
                    </div>

                    <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
                      {message.email || "Email non renseigné"} ·{" "}
                      {formatDateTime(getMessageDate(message))}
                    </p>
                  </div>

                  <div className="flex shrink-0 items-center gap-1">
                    <button
                      type="button"
                      onClick={() => onToggleRead(message.id)}
                      title={getReadButtonLabel(isRead)}
                      className="grid h-9 w-9 place-items-center rounded-xl border border-slate-200 bg-white text-slate-500 transition hover:border-blue-200 hover:text-blue-600 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-300"
                    >
                      {isRead ? <FaEnvelope /> : <FaRegEnvelope />}
                    </button>

                    <button
                      type="button"
                      onClick={() => onDelete(message.id)}
                      title="Supprimer"
                      className="grid h-9 w-9 place-items-center rounded-xl border border-slate-200 bg-white text-slate-500 transition hover:border-rose-200 hover:text-rose-600 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-300"
                    >
                      <FaTrashAlt />
                    </button>
                  </div>
                </div>

                <p className="mt-3 max-h-16 overflow-hidden text-sm leading-6 text-slate-600 dark:text-slate-300">
                  {message.message || "Aucun contenu."}
                </p>
              </article>
            );
          })}
        </div>
      ) : (
        <div className="rounded-3xl border border-dashed border-slate-300 bg-slate-50 p-8 text-center dark:border-slate-700 dark:bg-slate-950">
          <p className="font-bold text-slate-800 dark:text-slate-100">
            Aucun message reçu.
          </p>
          <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
            Les demandes envoyées depuis le site apparaîtront ici.
          </p>
        </div>
      )}
    </SectionCard>
  );
}